import { useQuery } from "@tanstack/react-query";
import { getSupabaseWithLogging } from "@/lib/hooks/api/utils";
import {
  TASK_WITH_RELATIONS_SELECT,
  applyTaskFilters,
  hydrateAssignedUsersForTasks,
} from "./helpers";

export function useTasksPaginated(params?: {
  page?: number;
  limit?: number;
  search?: string;
  contact_id?: string;
  status?: string;
  priority?: string;
  assigned_to?: string;
  assigned_users?: string[];
  user_id?: string;
}) {
  return useQuery({
    queryKey: ["tasks-paginated", params],
    queryFn: async () => {
      const supabase = getSupabaseWithLogging();

      let dataQuery = supabase.from("contact_tasks").select(TASK_WITH_RELATIONS_SELECT);
      let countQuery = supabase
        .from("contact_tasks")
        .select("*", { count: "exact", head: true });

      dataQuery = applyTaskFilters(dataQuery, params);
      countQuery = applyTaskFilters(countQuery, params);

      if (params?.limit) {
        const offset = ((params.page || 1) - 1) * params.limit;
        dataQuery = dataQuery.range(offset, offset + params.limit - 1);
      }

      const [dataResult, countResult] = await Promise.all([
        dataQuery.order("created_at", { ascending: false }),
        countQuery,
      ]);

      if (dataResult.error) {
        console.error("Error fetching tasks:", dataResult.error);
        throw new Error(dataResult.error.message);
      }

      if (countResult.error) {
        console.error("Error counting tasks:", countResult.error);
        throw new Error(countResult.error.message);
      }

      const data = dataResult.data || [];

      if (data && data.length > 0) {
        await hydrateAssignedUsersForTasks(data);
      }

      return {
        data,
        totalCount: countResult.count || 0,
      };
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
